<template>
    <div>
        <li class="nav-item dropdown">
            <b-dropdown ref="dropdown" id="notifications" variant="light" toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <i class="far fa-bell"></i>
                    <span class="badge badge-danger navbar-badge" v-if="total_unread">{{
                        total_unread
                    }}</span>
                </template>
                <b-dropdown-text>
                    <b-form-checkbox v-model="notify_status" v-if="!notify_status" name="check-button" switch>
                        Exibir no seu dispositivo:
                        <b>
                            <span v-if="notify_status">(sim)</span><span v-else>(não)</span></b>
                    </b-form-checkbox>
                    <span>{{ !btn_lidas ? total_unread : total_read }}
                        <small><b v-if="count()">Notificação</b><b v-else>Notificações</b></small></span>
                    <div class="w-100 d-flex justify-content-around">
                        <b-button size="sm" :variant="btn_lidas ? `link` : `outline-secondary`" @click="
                            btn_lidas = false;
                        loadNotifications();
                                          " :disabled="!btn_lidas">Não Lida(s)</b-button><b-button size="sm"
                            :variant="!btn_lidas ? `link` : `outline-secondary`" :disabled="btn_lidas" @click="
                                btn_lidas = true;
                            loadNotifications('read');
                                              ">Lida(s)</b-button>
                    </div>
                </b-dropdown-text>
                <b-dropdown-divider></b-dropdown-divider>
                <div v-if="items.length">
                    <Item v-for="(item, index) in items" :key="index" :item="item" @hideDropdown="hideDropdown"></Item>
                </div>
                <div v-observe-visibility="visibilityChanged" class="my-2"></div>
            </b-dropdown>
        </li>

        <modal id="verTarefa" key="notification">
            <Cartoes :cliente_id="cliente_id" :tarefa_id="tarefa_id" />
        </modal>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Item from "./Item.vue";
import Cartoes from "../tarefas/Cartoes.vue";
export default {
    components: { Item, Cartoes },
    data() {
        return {
            btn_lidas: false,
            cliente_id: null,
            tarefa_id: null,
            page: 1,
            lastPage: 1,
            notify_status: false,
        };
    },
    watch: {
        notify_status(newVal) {
            if (newVal) {
                localStorage.setItem("notify", "true");
                this.notifyMe();
            } else {
                localStorage.setItem("notify", "false");
            }
        },
        user(newVal) {
            if (newVal.user_id) {
                this.notify();
            }
        },
        parceiro(newVal) {
            if (newVal.user_id) {
                this.joinChannel();
            }
        },
    },
    created() {
        this.loadNotifications();

        this.$root.$on("verTarefa", (item) => {
            this.tarefa_id = item.data.model.tarefa.tarefa_id;
            this.cliente_id = item.data.model.tarefa.loja_id;
            this.$bvModal.show("verTarefa");
        });
    },
    mounted() {
        if (this.item) {
            this.page = this.item.current_page;
            this.lastPage = this.item.last_page;
        }
    },
    computed: {
        ...mapState("notification", ["total_read", "total_unread", "items"]),
        ...mapState("user", ["user", "parceiro"]),
    },
    methods: {
        ...mapActions("notification", ["loadNotifications"]),
        ...mapMutations("notification", ["MARK_ALL_AS_READ"]),
        hideDropdown() {
            this.$refs.dropdown.hide(true);
        },
        notify() {
            if ("Notification" in window) {
                if (Notification.permission === "granted") {
                    this.notify_status = true;

                    window.Echo.private(
                        "App.User." + this.user.user_id
                    ).notification((notification) => {
                        console.log("recebi uma notififcação", notification);

                        this.loadNotifications();

                        Notification.requestPermission(function (status) {
                            // status is "granted", if accepted by user
                            var n = new Notification("Econsulte", {

                                body: "Você recebeu uma nova notificação.",
                                icon: 'https://app.econsulte.com/images/logo-e.png', // optional,
                                data: {
                                    url: "https://app.econsulte.com"
                                }
                            });
                        });
                    });
                }

                let status_notify = localStorage.getItem("notify") || "true";

                if (Notification.permission === "default" && status_notify == "true") {
                    this.$swal
                        .fire({
                            icon: "question",
                            title: "Ativar notificações",
                            html: `<p>Receba notificações no seu dispositivo.</p>
                    <ul class="list-group">
                    <li class="list-group">Atualizações do sistema</li>
                    <li class="list-group">Encaminhamento de tarefas</li>
                    <li class="list-group">Menções em tarefas</li>
                    </ul>
                    `,
                            showDenyButton: true,
                            showCancelButton: false,
                            confirmButtonText: "Ativar",
                            denyButtonText: `Agora não`,
                        })
                        .then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
                                localStorage.setItem("notify", "true");
                                this.notifyMe();
                            } else if (result.isDenied) {
                                localStorage.setItem("notify", "false");
                            }
                        });
                }
            }
        },

        notifyMe() {
            // Let's check if the browser supports notifications
            if (!("Notification" in window)) {
                console.log("This browser does not support desktop notification");
            }

            // Let's check whether notification permissions have already been granted
            else if (Notification.permission === "granted") {
                // If it's okay let's create a notification
                //  let notification = new Notification("Notificações ativadas!");
                this.notify_status = true;
            }

            // Otherwise, we need to ask the user for permission
            else if (
                Notification.permission !== "denied" ||
                Notification.permission === "default"
            ) {
                Notification.requestPermission(function (permission) {
                    // If the user accepts, let's create a notification
                    if (permission === "granted") {
                        let notification = new Notification("Notificações ativadas!");
                    }
                });
            } else if (Notification.permission == "denied") {
                this.notify_status = false;
                this.$swal({
                    icon: "warning",
                    title:
                        "Você precisa desbloquear as notificações no seu navegador para ativar!",
                    html: "<a href='https://support.google.com/chrome/answer/3220216?hl=pt-BR&co=GENIE.Platform%3DDesktop&oco=0' target='_blank'>Ver tutorial</a>",
                });
            }

            // At last, if the user has denied notifications, and you
            // want to be respectful there is no need to bother them any more.
        },

        visibilityChanged(isVisible) {
            if (!isVisible) return;

            if (this.items.length >= 15) {
                if (this.page < this.lastPage) {
                    this.page = this.page + 1;
                    this.getLogs();
                }
            }
        },
        count() {
            if (!this.btn_lidas && this.total_unread == 1) {
                return true;
            } else if (this.btn_lidas && this.total_read == 1) {
                return true;
            }

            return false;
        },
        joinChannel() {
            window.Echo.join(`group.${this.parceiro.user_id}`)
                .here((users) => {
                    console.log("Usuários Online do grupo: " + this.parceiro.user_id);
                    console.log(users);

                    // store.commit('ADD_ONLINE_USERS', users)
                })
                .joining((user) => {
                    console.log("Entrou no grupo:" + this.parceiro.user_id);
                    console.log(user);

                    //   if (window.Notification && Notification.permission !== "denied") {
                    //     Notification.requestPermission(function (status) {
                    //       // status is "granted", if accepted by user
                    //       var n = new Notification("Title", {
                    //         body: "O usuário " + user.name + " entrou no grupo",
                    //         // icon: '/path/to/icon.png' // optional
                    //       });
                    //     });
                    //   }
                    // store.commit('ADD_ONLINE_USER', user)
                })
                .leaving((user) => {
                    console.log("Saiu do grupo:" + this.parceiro.user_id);
                    console.log(user);

                    //   if (window.Notification && Notification.permission !== "denied") {
                    //     Notification.requestPermission(function (status) {
                    //       // status is "granted", if accepted by user
                    //       var n = new Notification("Title", {
                    //         body: "O usuário " + user.name + " saiu",
                    //         // icon: '/path/to/icon.png' // optional
                    //       });
                    //     });
                    //   }
                });
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    #notifications .dropdown-menu {
        height: auto;
        max-height: 70vh;
        overflow-x: hidden;
        min-width: 268px;
        width: 100vw;
        max-width: 350px;
    }

    #notifcations .b-dropdown-text {
        padding: 0.6rem 1.5rem !important;
    }

    #notifications li:nth-child(even) {
        background: #f1f1f1;
    }

    #notifications li:nth-child(odd) {
        background: #fff;
    }
}
</style>
